import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing office information
 */
const create = () => {
    // Create BaseApi instance with provided options
    const api = BaseApi.create({
        errorCodes: [403, 404]
    });

    const getAllMyOffices = (impersonateId) => api.get(ApiPaths.GET_OFFICES(impersonateId));
    const getAllOffices = (impersonateId) => api.get(ApiPaths.GET_OFFICES(impersonateId));
    const getOfficeSummary = (officeId) => api.get(ApiPaths.GET_OFFICE_SUMMARY(officeId));

    // Return back a collection of functions
    return {
        getAllOffices, getOfficeSummary, getAllMyOffices
    }
}

// let's return back our create method as the default.
export default {
    create
}